import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import LogoCarouse from "../../Components/organisms/Home/LogoCarousel/LogoCarousel";
import { Images } from "../../helpers/Images";

const visionMissionCards = [
  {
    title: "Vision",
    icon: VisibilityOutlinedIcon,
    accent: "#23aef4",
    accentSoft: "rgba(35, 174, 244, 0.12)",
    accentBorder: "rgba(35, 174, 244, 0.22)",
    gradient: "linear-gradient(135deg, #23aef4 0%, #1a8fd4 100%)",
    description:
      "We strive to empower young minds with thrilling, authentic real challenges, foster teamwork, critical thinking, and an understanding of how innovation can create a positive impact on the world. This problem-solving mindset prepares the next generation of changemakers.",
  },
  {
    title: "Mission",
    icon: RocketLaunchOutlinedIcon,
    accent: "#c11a83",
    accentSoft: "rgba(193, 26, 131, 0.10)",
    accentBorder: "rgba(193, 26, 131, 0.22)",
    gradient: "linear-gradient(135deg, #c11a83 0%, #9e1569 100%)",
    description:
      "We aim to create an exceptional community where students aged 4 to 10 can demonstrate their skills and unlock their full potential. Through fostering a passion for technology, nurturing creativity, and promoting lifelong learning, we provide unmatched opportunities for growth, development, and enjoyable experiences, ensuring every participant thrives.",
  },
];

const AboutTemplate = () => {
  return (
    <Box
      sx={{
        width: "100%",
        padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
        maxWidth: "1500px",
        margin: "auto",
      }}
    >
      <Typography
        variant={"h1"}
        sx={{
          color: "primary.darker",
          fontSize: { xs: "34px", sm: "42px" },
          lineHeight: 1.15,
          fontWeight: 800,
          letterSpacing: "-0.02em",
          textAlign: { xs: "center" },
        }}
      >
        About Us
      </Typography>
      <Box
        sx={{
          height: "4px",
          width: { xs: "80px", md: "100px" },
          borderRadius: "999px",
          background: "linear-gradient(90deg, #23aef4 0%, #c11a83 100%)",
          margin: "10px auto 50px",
        }}
      />
      <Grid
        container
        spacing={{ xs: 4, md: 6 }}
        alignItems="center"
        justifyContent="space-between"
        sx={{
          maxWidth: "1500px",
        }}
      >
        <Grid item xs={12} md={7}>
          <Typography
            component="h2"
            sx={{
              color: "primary.darker",
              fontSize: { xs: "28px", sm: "34px" },
              lineHeight: 1.15,
              fontWeight: 800,
              letterSpacing: "-0.02em",
              textAlign: "start",
            }}
          >
            <Box
              component="span"
              sx={{
                background: "linear-gradient(90deg, #23aef4 0%, #c11a83 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Who Are We !
            </Box>
          </Typography>

          <Box
            sx={{
              height: "4px",
              width: { xs: "80px", md: "120px" },
              borderRadius: "999px",
              background: "linear-gradient(90deg, #23aef4 0%, #c11a83 100%)",
              margin: "10px 0 24px",
            }}
          />

          <Typography
            sx={{
              color: "primary.darker",
              lineHeight: 1.5,
              fontSize: { xs: "16px", md: "16px" },
              maxWidth: "600px",
              textAlign: "start",
              margin: { xs: "0 auto", md: "0" },
            }}
          >
            The{" "}
            <Box component="span" sx={{ color: "#23aef4", fontWeight: 700 }}>
              We Do Challenge
            </Box>{" "}
            is a unique global competition that ignites a passion for STEAM
            (Science, Technology, Engineering, Arts, and Mathematics) in young
            minds aged from 4 - 12 years through real-world problem-solving.
            Each year, a new global challenge is presented, and children
            collaborate to design, build, and program robots to address that
            challenge. This fosters teamwork, critical thinking, and an
            understanding of how innovation can create a positive impact on the
            world, this problem-solving mindset, prepares the next generation of
            changemakers
          </Typography>
        </Grid>

        <Grid item xs={12} md={5}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              maxWidth: { xs: "100%", md: "520px" },
              margin: { xs: "0 auto", md: "0 0 0 auto" },
            }}
          >
            <Box
              sx={{
                position: "absolute",
                inset: { xs: "-10px", md: "-14px" },
                borderRadius: "24px",
                background:
                  "linear-gradient(135deg, rgba(35, 174, 244, 0.35), rgba(193, 26, 131, 0.25))",
                filter: "blur(2px)",
                zIndex: 0,
              }}
            />
            <Box
              component="img"
              src={Images.main1}
              alt="Students building robots at We Do Challenge"
              sx={{
                position: "relative",
                zIndex: 1,
                width: "100%",
                minHeight: { xs: "220px", md: "300px" },
                objectFit: "cover",
                borderRadius: "20px",
                border: "1px solid rgba(255, 255, 255, 0.8)",
                boxShadow: "0 24px 60px rgba(10, 14, 24, 0.18)",
                display: "block",
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <Box
        component="section"
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: "1500px",
          margin: { xs: "48px auto 0", md: "64px auto 0" },
          padding: { xs: "40px 20px", sm: "48px 40px", md: "56px 48px" },
          borderRadius: { xs: "24px", md: "28px" },
          overflow: "hidden",
          background:
            "linear-gradient(180deg, #fafbfc 0%, #ffffff 45%, #f7f9fc 100%)",
          border: "1px solid rgba(89, 92, 97, 0.08)",
          boxShadow: "0 24px 60px rgba(10, 14, 24, 0.06)",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
            background:
              "radial-gradient(520px 280px at 0% 0%, rgba(35, 174, 244, 0.10), transparent 60%), radial-gradient(480px 260px at 100% 100%, rgba(193, 26, 131, 0.08), transparent 55%)",
          }}
        />

        <Box sx={{ position: "relative", textAlign: "center", mb: { xs: 4, md: 5 } }}>
          <Typography
            component="h2"
            sx={{
              color: "primary.darker",
              fontSize: { xs: "28px", sm: "34px" },
              lineHeight: 1.15,
              fontWeight: 800,
              letterSpacing: "-0.02em",
            }}
          >
            Our{" "}
            <Box
              component="span"
              sx={{
                background: "linear-gradient(90deg, #23aef4 0%, #c11a83 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Vision & Mission
            </Box>
          </Typography>
          <Box
            sx={{
              height: "4px",
              width: { xs: "80px", md: "100px" },
              borderRadius: "999px",
              background: "linear-gradient(90deg, #23aef4 0%, #c11a83 100%)",
              margin: "12px auto 0",
            }}
          />
        </Box>

        <Grid container spacing={{ xs: 3, md: 4 }} sx={{ position: "relative" }}>
          {visionMissionCards.map((card) => {
            const Icon = card.icon;
            return (
              <Grid item xs={12} md={6} key={card.title}>
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    padding: { xs: "28px 24px", md: "32px 28px" },
                    borderRadius: "20px",
                    backgroundColor: "#fff",
                    border: "1px solid rgba(89, 92, 97, 0.10)",
                    boxShadow: "0 12px 32px rgba(10, 14, 24, 0.06)",
                    transition: "transform 0.35s ease, box-shadow 0.35s ease",
                    "&:hover": {
                      transform: "translateY(-6px)",
                      boxShadow: "0 20px 48px rgba(10, 14, 24, 0.10)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 2.5,
                    }}
                  >
                    <Box
                      sx={{
                        width: 56,
                        height: 56,
                        borderRadius: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: card.gradient,
                        boxShadow: `0 10px 24px ${card.accentSoft}`,
                        flexShrink: 0,
                      }}
                    >
                      <Icon sx={{ fontSize: 28, color: "#fff" }} />
                    </Box>
                    <Box>
                      <Typography
                        component="h3"
                        sx={{
                          fontSize: { xs: "24px", md: "28px" },
                          fontWeight: 800,
                          letterSpacing: "-0.02em",
                          color: "primary.darker",
                          lineHeight: 1.2,
                        }}
                      >
                        {card.title}
                      </Typography>
                      <Box
                        sx={{
                          height: "3px",
                          width: "48px",
                          borderRadius: "999px",
                          background: card.gradient,
                          mt: 0.75,
                        }}
                      />
                    </Box>
                  </Box>

                  <Typography
                    sx={{
                      color: "primary.darker",
                      lineHeight: 1.7,
                      fontSize: { xs: "15px", md: "16px" },
                      opacity: 0.92,
                    }}
                  >
                    {card.description}
                  </Typography>

                  <Box
                    sx={{
                      mt: "auto",
                      pt: 2.5,
                      display: "inline-flex",
                      alignSelf: "flex-start",
                      px: 1.75,
                      py: 0.75,
                      borderRadius: "999px",
                      backgroundColor: card.accentSoft,
                      border: `1px solid ${card.accentBorder}`,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: 700,
                        letterSpacing: "0.08em",
                        textTransform: "uppercase",
                        color: card.accent,
                      }}
                    >
                      {card.title === "Vision" ? "Where we're headed" : "How we get there"}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>

      <LogoCarouse />
    </Box>
  );
};

export default AboutTemplate;
